// extracted by mini-css-extract-plugin
export default {"noOrderContainer":"NoOrder_noOrderContainer__ggixp","noOrderText":"NoOrder_noOrderText__+h4hR"};